export enum ImageSizes {
  S = '250',
  M = '500',
  L = '1000'
}
